<template>
  <div class="cards-list-root">
    <div class="header">
      <span class="title">
        {{ $t('WithdrawToCard | cardsListTitle') }}
      </span>
      <button class="add-card-link" @click="$emit('add-new-card')">
        {{ $t('WithdrawToCard | cardsListAddNewCard') }}
      </button>
    </div>

    <ul class="list">
      <card
        v-for="card of cards"
        :id="card.id"
        :key="card.id"
        :title="card.mask"
        @click-on-card="handleClick(card.id)"
      />
    </ul>
  </div>
</template>

<script>
import Card from './Card.vue'

export default {
  components: { Card },

  props: {
    cards: {
      type: Array,
      default: () => [],
    },
  },

  methods: {
    handleClick(cardId) {
      this.$emit('click-on-card', cardId)
    },
  },
}
</script>

<style scoped lang="scss">
.header {
  display: flex;
  justify-content: space-between;
  gap: 10px;
}

.title {
  color: var(--text-6);
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 130%; /* 20.8px */
}

.add-card-link {
  color: var(--brand);
  white-space: nowrap;
}

.list {
  margin-top: 20px;
  display: flex;
  flex-direction: column;
  gap: 10px;
}
</style>
